import { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { Stack } from "expo-router";
import { PublicGuard } from "./auth/guards/RouteGuards";
import LoginView from "./auth/views/LoginView";
import Colors from "../Resources/Color";
import { useCoachStore } from "./contexts/CoachStoreContext";

export const unstable_settings = {
  headerShown: false,
};

export default function LoginPage() {
  const coach = useCoachStore();

  useEffect(() => {
    if (typeof document === "undefined") return;

    document.title = "Efort Coach - Login";

    const upsertMetaByName = (name, content) => {
      const existing = document.querySelector(`meta[name="${name}"]`);
      const meta = existing || document.createElement("meta");
      meta.setAttribute("name", name);
      meta.setAttribute("content", content);
      if (!existing) document.head.appendChild(meta);
    };

    const upsertCanonical = (href) => {
      const existing = document.querySelector('link[rel="canonical"]');
      const link = existing || document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", href);
      if (!existing) document.head.appendChild(link);
    };

    upsertMetaByName(
      "description",
      "Log in to Efort Coach, the all-in-one powerlifting coaching platform to plan training blocks, manage competitions, review athlete videos and track billing."
    );
    upsertCanonical("https://app.efortcoach.com/login");
  }, []);

  return (
    <PublicGuard>
      <Stack.Screen
        options={{ headerShown: false, title: "Efort Coach - Login" }}
      />
      <View style={styles.containerLogin}>
        <LoginView coach={coach} />
      </View>
    </PublicGuard>
  );
}

const styles = StyleSheet.create({
  containerLogin: {
    backgroundColor: Colors.backgroundColor,
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    flex: 1,
    width: "100%",
    height: "100%",
  },
});
